import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import { BlankResponseType, BlankType } from "@/models/blanksInput.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import WSelect from "@/components/form/w-select.vue";
import quizUtils from "@/util/quizUtils";
let BlankAsTextSettingsDialog = class BlankAsTextSettingsDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "blank", void 0);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "realtimeBlankData", null);
    _defineProperty(this, "isVisible", true);
    _defineProperty(this, "highlightRequiredFields", false);
  }
  areAllBlankSetted() {
    return this.realtimeBlankData !== null && this.realtimeBlankData.responses.every(blankAnswer => !!blankAnswer.label?.trim()?.length);
  }
  mounted() {
    this.isVisible = this.visible;
    this.initRealtimeBlankData();
  }
  get LABEL_NB_MAX_CHARS() {
    return quizUtils.QUIZ_LABELS_NB_MAX_CHARS;
  }
  shouldDisplayError(answer) {
    return !answer.label?.trim().length && this.highlightRequiredFields;
  }
  initRealtimeBlankData() {
    if (this.blank) {
      this.realtimeBlankData = structuredClone(this.blank);
    } else {
      this.realtimeBlankData = {
        position: -1,
        type: BlankType.TEXT,
        responses: []
      };
    }
  }
  onVisibilityPropChanges() {
    this.isVisible = this.visible;
  }
  onBlankAnswerLabelUpdate(answer, label) {
    answer.label = label.trim();
  }
  toggleBlankAnswerCaseSensitivity(answer) {
    answer.caseSensitive = !answer.caseSensitive;
  }
  onBlankAnswerDelete(answerToDel) {
    if (this.realtimeBlankData?.responses?.length) {
      this.realtimeBlankData.responses = this.realtimeBlankData.responses.filter(answer => answer !== answerToDel);
    }
  }
  addBlankAnswer() {
    if (this.realtimeBlankData) {
      this.realtimeBlankData.responses.push({
        label: '',
        type: BlankResponseType.EXACT_MATCH,
        correctAnswer: true,
        caseSensitive: false
      });
    }
  }
  cancelSettingsEdit() {
    this.closeDialog();
  }
  validateSettings() {
    if (this.areAllBlankSetted()) {
      this.isVisible = false;
      return this.$emit('blankAsTextsSettingsUpdate', this.realtimeBlankData);
    } else {
      this.highlightRequiredFields = true;
    }
  }
  closeDialog() {
    this.isVisible = false;
    this.realtimeBlankData = null;
    return this.isVisible;
  }
};
__decorate([Prop({
  default: null
})], BlankAsTextSettingsDialog.prototype, "blank", void 0);
__decorate([Prop({
  required: true
})], BlankAsTextSettingsDialog.prototype, "visible", void 0);
__decorate([Watch('visible')], BlankAsTextSettingsDialog.prototype, "onVisibilityPropChanges", null);
__decorate([Emit("dialog-close")], BlankAsTextSettingsDialog.prototype, "closeDialog", null);
BlankAsTextSettingsDialog = __decorate([Component({
  components: {
    WSelect,
    WDialog,
    StandardButton,
    WInput
  },
  emits: ['blankAsTextsSettingsUpdate']
})], BlankAsTextSettingsDialog);
export default BlankAsTextSettingsDialog;